import { AppSelectOption } from '@/models/common/AppSelectOption';

const LOCALE = {
  AR: 'ar',
  EN: 'en',
  FR: 'fr',
  DA: 'da',
  DE: 'de',
  EL: 'el',
  PL: 'pl',
  PT: 'pt',
  RO: 'ro',
  ES: 'es',
  ES_MX: 'es-MX',
  SV: 'sv'
};

const LOCALE_LABEL = {
  [LOCALE.AR]: 'العربية',
  [LOCALE.EN]: 'English',
  [LOCALE.FR]: 'Français',
  [LOCALE.ES]: 'Español',
  [LOCALE.ES_MX]: 'Español Mexicano',
  [LOCALE.PT]: 'Português',
  [LOCALE.PL]: 'Polski',
  [LOCALE.DE]: 'Deutsch',
  [LOCALE.RO]: 'Română',
  [LOCALE.EL]: 'Ελληνικά',
  [LOCALE.DA]: 'Dansk',
  [LOCALE.SV]: 'Svenska'
};

const SUPPORTED_LOCALES = Object.values(LOCALE);
const DEFAULT_LOCALE = LOCALE.EN;

const SUPPORTED_LOCALES_SELECT_OPTIONS = SUPPORTED_LOCALES.reduce((options, localeCode) => {
  const option = new AppSelectOption(LOCALE_LABEL[localeCode], localeCode);

  return { ...options, [localeCode]: option };
}, {});

export {
  LOCALE,
  LOCALE_LABEL,
  SUPPORTED_LOCALES,
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES_SELECT_OPTIONS
};
